<div class="fuse-vertical-navigation-wrapper "
     style=" background: transparent linear-gradient(181deg, #0C1C45 0%, #02050D 100%) 0% 0% no-repeat padding-box;">

    <!-- Header -->
    <div class="fuse-vertical-navigation-header">
        <ng-content select="[fuseVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="fuse-vertical-navigation-content"
        fuseScrollbar
        [fuseScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}"
        #navigationContent>

        <!-- Content header -->
        <div class="fuse-vertical-navigation-content-header">
            <ng-content select="[fuseVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">
                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <fuse-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [activeItemId]="activeAsideItemId"
                        [autoCollapse]="autoCollapse"
                        [skipChildren]="true"
                        (click)="toggleAside(item)"></fuse-vertical-navigation-aside-item>
                </ng-container>

                <!-- Basic -->
                <ng-container *ngIf="item.type === 'basic'">
                    <fuse-vertical-navigation-basic-item 
                        [item]="item"
                        [name]="name"></fuse-vertical-navigation-basic-item>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <fuse-vertical-navigation-collapsable-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <fuse-vertical-navigation-divider-item
                        [item]="item"
                        [name]="name"></fuse-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group' " >
                    <fuse-vertical-navigation-group-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <fuse-vertical-navigation-spacer-item
                        [item]="item"
                        [name]="name"></fuse-vertical-navigation-spacer-item>
                </ng-container>

            </ng-container>

        </ng-container>

        <!--    Filters starts here-->
        <ng-container *ngIf="!isAdmin">
            <fuse-vertical-navigation-group-item
                class="mt-0 text-white"
                [item]="filtersGroupTitle"
                [name]="name"
                [autoCollapse]="autoCollapse"></fuse-vertical-navigation-group-item>
        </ng-container>
        <ng-container *ngIf="!isAdmin">
            <fuse-vertical-navigation-divider-item 
                style="margin:0; margin-left: 16px;margin-right: auto;width: 80%"
                [item]="devider"
                [name]="name"></fuse-vertical-navigation-divider-item>
        </ng-container>
        <!--Search By Anomaly ID/Master(asset) ID-->
        <ng-container *ngIf="isAnomalyIDShown || isMasterIDShown">
            <div class="search-outline relative left-[0.7vw] top-[1.5vh]">
                <mat-form-field class="flex justify-center " style="padding:4px !important" *ngIf="isAnomalyIDShown">   
                    <input matInput type="text" (keyup.enter)="enterAnomalyID($event.target.value)"  [(value)] = "shiftDataService.anomalyID" class="relative bottom-[0vh] right-[0.5vw] input-value" [placeholder]="dashboardService.translate('Search Anomaly ID')">       
                    <mat-icon class="absolute right-[0.8vw] bottom-[0.8vh]" style="min-width: 12px !important;width: 18px;height: 18px;flex-shrink: 0;" [svgIcon]="'heroicons_solid:search-id'"></mat-icon>
                </mat-form-field>

                <mat-form-field class="flex justify-center " style="padding:4px !important" *ngIf="isMasterIDShown">   
                    <input matInput type="text" (keyup.enter)="enterMasterID($event.target.value)"  [(value)] = "shiftDataService.masterID" class="relative bottom-[0vh] right-[0.5vw] input-value" [placeholder]="dashboardService.translate('Search Master ID')">       
                    <mat-icon class="absolute right-[0.8vw] bottom-[0.8vh]" style="min-width: 12px !important;width: 18px;height: 18px;flex-shrink: 0;" [svgIcon]="'heroicons_solid:search-id'"></mat-icon>
                </mat-form-field>
            </div>
        </ng-container>
        <ng-container *ngIf="!isAdmin">
            <fuse-vertical-navigation-basic-item  class="relative top-[2.5vh]"
                [item]="siteName"
                [name]="name"></fuse-vertical-navigation-basic-item>
        </ng-container>
        <!--date filter in dashboard-->
        <!--ng-container *ngIf="isDashBoard">
            <fuse-vertical-navigation-basic-item
                [item]="dateFilter"
                [name]="name"></fuse-vertical-navigation-basic-item>
        </ng-container-->
        <ng-container *ngIf="isShowFilters && !isAdmin">
            <!-- //configuration files-->
            <ng-container *ngIf="!isMaple">
                <fuse-vertical-navigation-collapsable-item class="relative top-[2.5vh]"
                    [item]="chainage"
                    [name]="name"
                    [autoCollapse]="autoCollapse"
                    [ngClass]="{ 'disabled': displayChainage }"
                    [chainage]="true"></fuse-vertical-navigation-collapsable-item>
            </ng-container>
            <ng-container *ngIf="isMaple">
                <fuse-vertical-navigation-basic-item class="relative top-[2.5vh]"
                    [item]="chainages"
                    [name]="name"></fuse-vertical-navigation-basic-item>
            </ng-container>
            <div class="flex items-center relative top-[2.5vh]">
                <fuse-vertical-navigation-basic-item
                    [item]="dateFilter"
                    [name]="name"
                    class="flex-1"
                ></fuse-vertical-navigation-basic-item>

                <mat-icon *ngIf="isAnomalyPage" class="scale-75 mr-[13px] cursor-pointer text-yellow-500" [svgIcon]="'mat_solid:info'"
                    matTooltip="Click for info" [matMenuTriggerFor]="infoMenu" (menuOpened)="isMenuOpen = true" (menuClosed)="isMenuOpen = false"
                ></mat-icon>
            </div>
            <mat-menu #infoMenu="matMenu" class="tooltip-menu ">
                <div class="p-1 m-1 italic opacity-90">
                    Select a data or date range to view anomalies detected on those specific dates, and how many out of those are completed as of today.
                </div>
            </mat-menu>
            <ng-container *ngIf="!isAdmin">
                <fuse-vertical-navigation-basic-item class="relative top-[2.5vh]"
                    [item]="assets"
                    [name]="name"
                ></fuse-vertical-navigation-basic-item>
            </ng-container>
            <ng-container *ngIf="!isAdmin">
                <fuse-vertical-navigation-basic-item class="relative top-[2.5vh]"
                    [item]="category"
                    [name]="name"
                ></fuse-vertical-navigation-basic-item>
            </ng-container>
            <!--verification filter changes-->
            <!-- <ng-container *ngIf="isWorkOrder && !isAdmin">
                <fuse-vertical-navigation-basic-item class="relative top-[2.5vh]"
                    [item]="verification_type"
                    [name]="name"
                    [ngClass]="{ 'disabled': isVeificationFilterDisabled }">
                </fuse-vertical-navigation-basic-item>
            </ng-container> -->
            <!--Section filter changes-->
            <!--ng-container>
                <fuse-vertical-navigation-basic-item
                    [item]="section_filter"
                    [name]="name"
                ></fuse-vertical-navigation-basic-item>
            </ng-container-->
        </ng-container>
        <!--        Filters ends here-->


        <!-- Content footer -->
        <div class="fuse-vertical-navigation-content-footer">
            <ng-content select="[fuseVerticalNavigationContentFooter]"></ng-content>
        </div>

    </div>

    <!-- Footer -->
    <div class="fuse-vertical-navigation-footer" style="margin-bottom: 1rem">
        <!--change password-->
        <!--ng-container *ngIf="true">
            <fuse-vertical-navigation-basic-item
                [item]="changePassword"
                [name]="name">
            </fuse-vertical-navigation-basic-item>
        </ng-container-->
        <!-- upload videos only in jhnsw site -->
        <ng-container *ngIf="uploadFiles">
            <fuse-vertical-navigation-basic-item
                [item]="upload"
                [name]="name"        
            ></fuse-vertical-navigation-basic-item>
        </ng-container>
        <ng-container>
            <fuse-vertical-navigation-basic-item
                [item]="tickets"
                [name]="name"        
            ></fuse-vertical-navigation-basic-item>
        </ng-container>
        <ng-container *ngIf="!hideDownloadReport">
            <fuse-vertical-navigation-basic-item
                [item]="downloadReport"
                [name]="name"
                [ngClass]="{ 'disabled': isDownloadDisable }"
            ></fuse-vertical-navigation-basic-item>
        </ng-container>
        <ng-container *ngIf="isShowFilters">
            <fuse-vertical-navigation-divider-item
                style="margin:0; margin-left: 16px;margin-right: auto;width: 80%"
                [item]="devider"
                [name]="name"></fuse-vertical-navigation-divider-item>
        </ng-container>
        <ng-container>
            <fuse-vertical-navigation-basic-item
                [item]="logout"
                [name]="name"
            ></fuse-vertical-navigation-basic-item>
        </ng-container>
        <!-- Container for nav + popup -->
        <div class="new-feature-container">
            <ng-container>
                <fuse-vertical-navigation-basic-item
                    [item]="newFeature"
                    [name]="name"
                ></fuse-vertical-navigation-basic-item>
            </ng-container>

            <!-- BACKDROP OVERLAY -->
            <div *ngIf="popupVisible" class="overlay-backdrop" (click)="closePopup()"></div>

                <!-- Fixed-position Popup -->
                <div *ngIf="popupVisible" class="popup-fixed">
                    <div class="popup-content">
                        <div class="popup-close">
                            <mat-icon [svgIcon]="'custom:close'" (click)="closePopup()" style="cursor: pointer;"></mat-icon>
                        </div>
                    <div>
                    <span style="background-color: #080843; color: white; font-size: 11px; font-weight: bold; padding: 2px 6px; border-radius: 9999px; margin-right: 6px;">NEW</span>
                    <span style="color: black; font-weight: 700;">Version 1.3</span>
                    <p style="color: black; max-width: 300px; font-size: 14px;"> Enhanced map features now available in the dashboard</p>
                </div>
            </div>
        </div>
        <!-- <p class="text-sm text-gray-500 absolute left-[20%]">Version: 1.3.5 </p> -->

        <!--        <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>-->
    </div>

</div>

<!-- Aside -->
<ng-container *ngIf="activeAsideItemId">
    <div
        class="fuse-vertical-navigation-aside-wrapper"
        fuseScrollbar
        [fuseScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
        [@fadeInLeft]="position === 'left'"
        [@fadeInRight]="position === 'right'"
        [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'">

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside' && item.id === activeAsideItemId">
                    <fuse-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-aside-item>
                </ng-container>

            </ng-container>

        </ng-container>

    </div>
</ng-container>
